<div class="selection-bar">
	@for (row of selections(); track row) {
		<div class="element" [class.active]="row === selection()">
			<a (click)="selection.set(row)">
				{{ row }}
			</a>
		</div>
	}
</div>
